(() => {
  const pending = new WeakSet();
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.querySelector('[name="form_type"]')?.value !== 'customer') return;
    const email = form.querySelector('[name="contact[email]"]');
    if (!email) return;
    // Own newsletter submissions, including cloned mobile/desktop footers.
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!form.reportValidity() || pending.has(form)) return;
    pending.add(form);
    const buttons = [...form.querySelectorAll('[type="submit"]')];
    const disabled = buttons.map(button => button.disabled);
    buttons.forEach(button => { button.disabled = true; });
    let status = form.parentElement.querySelector('[data-daisy-newsletter-status]');
    if (!status) {
      status = document.createElement('p');
      status.dataset.daisyNewsletterStatus = '';
      status.setAttribute('role', 'status');
      status.style.cssText = 'position:static;margin:8px 0 0;font:inherit;font-size:12px;color:inherit;line-height:1.2';
      form.insertAdjacentElement('afterend', status);
    }
    if (getComputedStyle(form).position === 'absolute') {
      Object.assign(status.style, {position:'absolute', margin:'0', top:`${form.offsetTop+form.offsetHeight+8}px`, left:`${form.offsetLeft}px`, width:`${form.offsetWidth}px`});
    }
    status.textContent = 'Subscribing...';
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=Yjjsqh', {
        method: 'POST',
        headers: {'content-type': 'application/json', revision: '2026-07-15'},
        signal: controller.signal,
        body: JSON.stringify({data: {
          type: 'subscription',
          attributes: {custom_source: 'Daisy Website Newsletter', profile: {data: {type: 'profile', attributes: {email: email.value.trim()}}}},
          relationships: {list: {data: {type: 'list', id: 'Ygu4h8'}}}
        }})
      });
      if (!response.ok) throw new Error('Subscription failed');
      status.textContent = 'Thank you for subscribing! Stay Tuned.';
      form.reset();
    } catch (_) {
      status.textContent = 'We could not confirm your signup. Please try again.';
    } finally {
      clearTimeout(timeout);
      pending.delete(form);
      buttons.forEach((button, index) => { button.disabled = disabled[index]; });
    }
  }, true);
})();
